import React from 'react';

const ForbiddenComponent = () => (
  <>
    <div>No tienes suficientes permisos</div>
  </>
);

export default ForbiddenComponent;
